import React from 'react'
import { useConfig } from '../../../contexts/ConfigContext';

import {
  RightCenterContainer,
} from './styles'

export const RightCenter = () => {

  const [configState] = useConfig()
  const currentLng = localStorage.getItem('i18nextLng');

  return (
    <RightCenterContainer>
      {!configState?.loading && configState?.configs?.background_logo && (
        <img src={configState.configs.background_logo} alt="right logo" className="rightLogo" />
      )}
      <h1>{currentLng === 'en' ? configState?.configs?.appEnName : configState?.configs?.appArName}</h1>
    </RightCenterContainer>
  )
}
